import { IModules, IP35CategoryDetailPage, IP40ProductListPage } from '~/lib/data-contract';
import { BlendingBackground } from '~/shared/components/BlendingBackground/BlendingBackground';
import { Headline } from '~/shared/components/Headline/Headline';
import { DynamicBlockList } from '~/templates/blocks/components/DynamicBlockList/DynamicBlockList';
import { M170ProductFilter } from '~/templates/blocks/components/M170ProductFilter/M170ProductFilter';
import { M20Categories } from '~/templates/blocks/components/M20Categories/M20Categories';
import { M21Categories } from '~/templates/blocks/components/M21Categories/M21Categories';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer/ModuleContainer';
import { N55Breadcrumb } from '~/templates/blocks/components/N55Breadcrumb/N55Breadcrumb';

import styles from './P40ProductListPage.module.css';

export type P40ProductListPageProps = IP40ProductListPage | IP35CategoryDetailPage;

export const P40ProductListPage = (props: P40ProductListPageProps) => {
	const { breadcrumb, productFilterModule, categoriesModule } = props;

	if (!productFilterModule || !categoriesModule) {
		return null;
	}

	return (
		<>
			<div>
				<BlendingBackground>
					<ModuleContainer noMargin>
						{!!breadcrumb && (
							<N55Breadcrumb
								breadcrumb={breadcrumb}
								className={styles.breadcrumb}
							/>
						)}
						<Headline
							size={3}
							as={categoriesModule.headline?.tag || 'h1'}
							className={styles.headline}
						>
							{categoriesModule.headline?.text}
						</Headline>
					</ModuleContainer>
				</BlendingBackground>
				{categoriesModule.categoryImages ? (
					<M21Categories
						{...categoriesModule}
						hideHeadline
					/>
				) : (
					<M20Categories {...categoriesModule} />
				)}
				<M170ProductFilter
					initialData={productFilterModule}
					listName={categoriesModule.headline?.text}
					listId={productFilterModule.id}
				/>
			</div>
			<DynamicBlockList elements={props.pageElements as unknown as IModules[]} />
			{/* TODO: Fix cast to IModules */}
		</>
	);
};
